import {
  BoldOutlined,
  ItalicOutlined,
  StrikethroughOutlined,
  UnderlineOutlined,
} from '@ant-design/icons';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { Namespace } from '@data/utils/enums';
import { Button } from '@ui/components';
import { getIconStyles } from '../../utils';
import { useTextFormatting } from './hooks';

const iconStyles = getIconStyles();

type TextFormattingProps = {
  disabled: boolean;
};

export const TextFormatting = ({ disabled }: TextFormattingProps) => {
  const { t } = useTranslation([Namespace.ADMIN]);

  const {
    isBold,
    isStrikethrough,
    isUnderline,
    isItalic,
    formatBold,
    formatItalic,
    formatUnderline,
    formatStrikethrough,
  } = useTextFormatting();

  return (
    <div className="flex items-center gap-1">
      <Button
        type="text"
        className={cx('p-2 rounded-md', isBold && 'bg-blue-300')}
        onClick={formatBold}
        disabled={disabled}
        title={t('editor.titles.bold')}
      >
        <BoldOutlined style={iconStyles} />
      </Button>
      <Button
        type="text"
        disabled={disabled}
        className={cx('p-2 rounded-md', isItalic && 'bg-blue-300')}
        onClick={formatItalic}
        title={t('editor.titles.italic')}
      >
        <ItalicOutlined style={iconStyles} />
      </Button>
      <Button
        type="text"
        disabled={disabled}
        className={cx('p-2 rounded-md', isUnderline && 'bg-blue-300')}
        onClick={formatUnderline}
        title={t('editor.titles.underline')}
      >
        <UnderlineOutlined style={iconStyles} />
      </Button>
      <Button
        type="text"
        disabled={disabled}
        className={cx('p-2 rounded-md', isStrikethrough && 'bg-blue-300')}
        onClick={formatStrikethrough}
        title={t('editor.titles.strike_through')}
      >
        <StrikethroughOutlined style={iconStyles} />
      </Button>
    </div>
  );
};
